import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  PRODUCT_SETTINGS_APPLICATIONS_PATH,
  PRODUCT_SETTINGS_PLANS_AND_USAGE_PATH,
} from "routes/shared/coreRoutes";

/**
 * Old /profile (tabbed Company / Personal / Referral / Apps / SSO) → new settings routes.
 * Default landing is the Global settings hub.
 */
function resolveProfileRedirect({ search, hash, state }) {
  const params = new URLSearchParams(search || "");
  const closeParam = params.get("close");
  if (closeParam === "True" || closeParam === "true" || closeParam === "1") {
    return "/profile/sso_complete";
  }

  if (state?.apps_marketplace === true) {
    return PRODUCT_SETTINGS_APPLICATIONS_PATH;
  }

  if (hash === "#membership-details") {
    return PRODUCT_SETTINGS_PLANS_AND_USAGE_PATH;
  }

  const tab = params.get("tab");
  switch (tab) {
    case "personal-settings":
      return "/personal-settings";
    case "company-settings":
      return "/business-settings?tab=business";
    case "referral":
    case "referral-program":
      return "/business-settings?tab=referral";
    case "applications":
    case "l-workspace-marketplace":
      return PRODUCT_SETTINGS_APPLICATIONS_PATH;
    case "team-security":
    case "sso":
      return "/business-settings?tab=sso";
    default:
      return "/global-settings";
  }
}

export default function ProfileRedirect() {
  const location = useLocation();
  const to = resolveProfileRedirect(location);

  return <Navigate to={to} replace state={location.state} />;
}
